<router-outlet></router-outlet>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(209, 175, 130)" type="ball-scale-multiple" [fullScreen] = "true">
    <p style="color:hsl(194, 65%, 48%);font-weight: bold" > Loading... </p>
</ngx-spinner>

<!--<angular-editor [(ngModel)]="htmlContent" [config]="editorConfig"></angular-editor>-->
<!--<ngb-datepicker id='gfg'></ngb-datepicker>-->
